<template>
  <!-- <div class="spinner">
    <img src="../assets/loading.svg" alt="loading"/>
  </div> -->
  <div>
    <circle4></circle4>
  </div>
</template>

<script>
  import {Circle4} from 'vue-loading-spinner'
  export default {
    name: 'logout',
    props: ['auth'],
    data () {
      this.auth.logout(this.$route.query.id, this.$route.query.jwt)
      // console.log(this.$route.query.id)
      return {}
    },
    components: {
      Circle4
    }
  }
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// Logout.vue?3ea2abc4